export enum ConfirmMessagePosition {
	topCenter = 'top',
	topRight = 'topright',
	topLeft = 'topleft',
	bottomCenter = 'bottom',
	bottomRight = 'bottomright',
	bottomLeft = 'bottomleft',
	center = 'center',
}
